import { PassengerTypeEnum } from '../constants/PassengerTypes';

const getPassengersNotInfantType = (passengers, rebookPaxDetails) => {
  const passengerTypeArr = [];
  //based on passenger type enum
  const allowedPassengerTypes = [1, 5];
  let counter = 0;
  for (let i = 0; i < passengers.length; i++) {
    if (
      (passengers[i].Type === PassengerTypeEnum.Infant ||
        passengers[i].Type === PassengerTypeEnum.InfantWithSeat) &&
      counter === 0
    ) {
      if (passengers[i].AssociateTravellers !== null) {
        for (const pax of passengers[i].AssociateTravellers) {
          if (pax.RefNo !== 0) {
            passengerTypeArr.push({
              label: pax.Name,
              value: pax.RefNo.toString(),
            });
          } else {
            passengerTypeArr.push({
              label: 'Choose an Adult',
              value: '',
            });
          }
        }
        counter++;
      }
    }
  }
  return passengerTypeArr;
};

export const validateTravelerRefNumberForInfant = (passengers) => {
  const infantPax = passengers.filter((pax) => pax.associateTravelerRefNumber !== 0);
  const uniqueValues = new Set(infantPax.map((v) => v.associateTravelerRefNumber));
  if (uniqueValues.size < infantPax.length) {
    return false;
  }
  return true;
};

export const setTravelerRefNumber = (passenger) => {
  if (
    passenger.PassengerType === 'INS' ||
    passenger.PassengerType === 'INF' ||
    passenger.Type === PassengerTypeEnum.Infant
  ) {
    return '';
  } else if (passenger.PassengerType === 'CHD') {
    return 0;
  } else {
    return 0;
  }
};
export default getPassengersNotInfantType;
